// Errors
// UI/Tools
import ScrollToTop from "@components/ui/ScrollToTop";
import { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";

const Home = lazy(() => import("./Home"));
const AboutUs = lazy(() => import("./AboutUs"));
const ContactUs = lazy(() => import("./ContactUs"));
const Services = lazy(() => import("./Services"));
const Industries = lazy(() => import("./Industries"));
const IndustryDetails = lazy(() => import("./IndustryDetails"));
const Insights = lazy(() => import("./Insights"));
const Press = lazy(() => import("./Press"));
const MediaCenter = lazy(() => import("./MediaCenter"));
const OurClients = lazy(() => import("./OurClients"));
const Terms = lazy(() => import("./Terms"));
const Privacy = lazy(() => import("./Privacy"));
const Cookies = lazy(() => import("./Cookies/index"));
const Error404 = lazy(() => import("@components/layout/errors/Error404"));
const Error500 = lazy(() => import("@components/layout/errors/Error500"));


export default function Index() {

  return (
    <div className='vh-100'>
      <Suspense fallback={null}>
        <ScrollToTop />
        <Routes>
          <Route index path='/' element={<Home />} />
          <Route path='/about-us' element={<AboutUs />} />
          <Route path='/contact-us' element={<ContactUs />} />
          <Route path='/services' element={<Services />} />
          <Route path='/services/:categoryId' element={<Services />} />
          <Route path='/industries' element={<Industries />} />
          <Route path='/industry-details/:id' element={<IndustryDetails />} />
          <Route path='/insights' element={<Insights />} />
          <Route path='/presses' element={<Press />} />
          <Route path='/media-center/:mediaType/:id' element={<MediaCenter />} />
          <Route path='/our-clients' element={<OurClients />} />
          <Route path='/terms' element={<Terms />} />
          <Route path='/privacy' element={<Privacy />} />
          <Route path='/cookies' element={<Cookies />} />
          <Route path='*' element={<Error404 />} />
          <Route path='/error-500' element={<Error500 />} />
        </Routes>
      </Suspense>
    </div>
  )
}
